module.exports = __webpack_public_path__ + "static/media/Popup-ilmoitus.a8d200b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/screenCaptures/Popup-ilmoitus.png
// module id = 1431
// module chunks = 0